import './assets/main.scss'

import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import i18n from './i18n';
import VCalendar from 'v-calendar';

import * as Sentry from "@sentry/vue";

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://325174e9083095805575139e40fc7f66@o4504932444471296.ingest.us.sentry.io/4509865238200320",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(VCalendar, {})

app.mount('#app')
